/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Convert_To_SubtitlesInputs */



/**
* | output |
* | --- |
* | "Convert To Subtitles" |
*
* @param {Event_Group_Options_Convert_To_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_convert_to_subtitles = /** @type {((inputs?: Event_Group_Options_Convert_To_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Convert_To_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Convertir en sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("In Untertitel umwandeln")
	if (locale === "it") return /** @type {LocalizedString} */ ("Converti in sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразовать в субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertir a subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转换为字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕に変換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षकों में बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter em legendas")
	return /** @type {LocalizedString} */ ("Convert To Subtitles")
});